export default "__VITE_ASSET__CUNrhyKp__"